import { render } from "./GenderData.vue?vue&type=template&id=412e952e&scoped=true"
import script from "./GenderData.vue?vue&type=script&lang=js"
export * from "./GenderData.vue?vue&type=script&lang=js"

import "./GenderData.vue?vue&type=style&index=0&id=412e952e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412e952e"]])

export default __exports__